import { MutationTree } from 'vuex';

// Shared types
import { Company } from '@coldtec/cos-types';

// Store types
import { RootState, CompanyMutation } from '@/store/store.types';

// Steps and step types
import Steps from '@/steps/steps';
import { Step } from '@/steps/types';

// Footer
import { FooterInfo } from '../footer/footer.types';

/**
 *  Holding all the mutations of the steps.
 */
export const Mutations: MutationTree<RootState> = {

    /**
     *  Used to store the company details of the company for which
     *  the tool is currently used and interpolate the space's
     *  footer info with the details.
     */
    [CompanyMutation.DETAILS](state: RootState, company: Company): void {

        state.company.details = company;

        /**
         *  Get the info to interpolate.
         */
        const info: FooterInfo = Steps[Step.Spaces].info as FooterInfo;

        /**
         *  Interpolate the spaces' info with the correct properties.
         */
        const props: Array<keyof Company> = [
            'name',
            'phone_number',
            'formatted_phone_number',
            'email',
        ];

        for (const prop of props) {

            if (typeof company[prop] !== 'string') {

                continue;

            }

            info.content = info.content.replace(new RegExp(`{${ prop }}`, 'g'), company[prop] as string);

        }

        Steps[Step.Spaces].info = info;

        /**
         *  Update the default info texts of the systems' and overview's steps.
         */
        if (!company.texts) {

            return;

        }

        Steps[Step.Systems].info = {
            content: company.texts.info_systems,
            small: company.texts.info_systems_short,
        };

        Steps[Step.Overview].info = {
            content: company.texts.info_overview,
            small: company.texts.info_overview_short,
        };

    },

};
